import {
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb,
  ULong3f9k7s38t3rfp as ULong,
} from './ULong.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from './exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { contains2ejsq2kq1axf2 as contains } from './collections/_Arrays.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
import { Collection1k04j3hzsbod0 as Collection } from './collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ULongArray___init__impl__twm1l3(storage) {
  return storage;
}
function _ULongArray___get_storage__impl__28e64j($this) {
  return $this;
}
function _ULongArray___init__impl__twm1l3_0(size) {
  return _ULongArray___init__impl__twm1l3(new BigInt64Array(size));
}
function ULongArray__get_impl_pr71q9($this, index) {
  // Inline function 'kotlin.toULong' call
  var this_0 = _ULongArray___get_storage__impl__28e64j($this)[index];
  return _ULong___init__impl__c78o9k(this_0);
}
function ULongArray__set_impl_z19mvh($this, index, value) {
  var tmp = _ULongArray___get_storage__impl__28e64j($this);
  // Inline function 'kotlin.ULong.toLong' call
  tmp[index] = _ULong___get_data__impl__fggpzb(value);
}
function _ULongArray___get_size__impl__ju6dtr($this) {
  return _ULongArray___get_storage__impl__28e64j($this).length;
}
function ULongArray__iterator_impl_cq4d2h($this) {
  return new (Iterator())(_ULongArray___get_storage__impl__28e64j($this));
}
var IteratorClass;
function Iterator() {
  if (IteratorClass === VOID) {
    class $ {
      constructor(array) {
        this.array_1 = array;
        this.index_1 = 0;
      }
      hasNext_bitz1p_k$() {
        return this.index_1 < this.array_1.length;
      }
      next_mi4vn2_k$() {
        var tmp;
        if (this.index_1 < this.array_1.length) {
          var _unary__edvuaz = this.index_1;
          this.index_1 = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.toULong' call
          var this_0 = this.array_1[_unary__edvuaz];
          tmp = _ULong___init__impl__c78o9k(this_0);
        } else {
          throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$(this.index_1.toString());
        }
        return tmp;
      }
      next_20eer_k$() {
        return new (ULong())(this.next_mi4vn2_k$());
      }
    }
    initMetadataForClass($, 'Iterator');
    IteratorClass = $;
  }
  return IteratorClass;
}
function ULongArray__contains_impl_v9bgai($this, element) {
  var tmp = _ULongArray___get_storage__impl__28e64j($this);
  // Inline function 'kotlin.ULong.toLong' call
  var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
  return contains(tmp, tmp$ret$0);
}
function ULongArray__contains_impl_v9bgai_0($this, element) {
  if (!(element instanceof ULong()))
    return false;
  return ULongArray__contains_impl_v9bgai($this.storage_1, element instanceof ULong() ? element.data_1 : THROW_CCE());
}
function ULongArray__isEmpty_impl_c3yngu($this) {
  return _ULongArray___get_storage__impl__28e64j($this).length === 0;
}
function ULongArray__toString_impl_wqk1p5($this) {
  return 'ULongArray(storage=' + toString($this) + ')';
}
function ULongArray__hashCode_impl_aze4wa($this) {
  return hashCode($this);
}
function ULongArray__equals_impl_vwitwa($this, other) {
  if (!(other instanceof ULongArray()))
    return false;
  var tmp0_other_with_cast = other.storage_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ULongArrayClass;
function ULongArray() {
  if (ULongArrayClass === VOID) {
    class $ {
      constructor(storage) {
        this.storage_1 = storage;
      }
      get_size_woubt6_k$() {
        return _ULongArray___get_size__impl__ju6dtr(this.storage_1);
      }
      iterator_jk1svi_k$() {
        return ULongArray__iterator_impl_cq4d2h(this.storage_1);
      }
      contains_hoxyov_k$(element) {
        return ULongArray__contains_impl_v9bgai(this.storage_1, element);
      }
      contains_aljjnj_k$(element) {
        return ULongArray__contains_impl_v9bgai_0(this, element);
      }
      isEmpty_y1axqb_k$() {
        return ULongArray__isEmpty_impl_c3yngu(this.storage_1);
      }
      toString() {
        return ULongArray__toString_impl_wqk1p5(this.storage_1);
      }
      hashCode() {
        return ULongArray__hashCode_impl_aze4wa(this.storage_1);
      }
      equals(other) {
        return ULongArray__equals_impl_vwitwa(this.storage_1, other);
      }
    }
    initMetadataForClass($, 'ULongArray', VOID, VOID, [Collection()]);
    ULongArrayClass = $;
  }
  return ULongArrayClass;
}
//region block: exports
export {
  _ULongArray___init__impl__twm1l3_0 as _ULongArray___init__impl__twm1l39g76mgefo3i0,
  _ULongArray___init__impl__twm1l3 as _ULongArray___init__impl__twm1l32hx2p2tkf1yk,
  ULongArray__get_impl_pr71q9 as ULongArray__get_impl_pr71q9399vaqruv2nhv,
  ULongArray__set_impl_z19mvh as ULongArray__set_impl_z19mvhkfwz87ruujvs,
  _ULongArray___get_size__impl__ju6dtr as _ULongArray___get_size__impl__ju6dtr202zbq0mnq27s,
  _ULongArray___get_storage__impl__28e64j as _ULongArray___get_storage__impl__28e64jr3nto0sn44go,
  ULongArray as ULongArray3nd0d80mdwjj8,
};
//endregion

//# sourceMappingURL=ULongArray.mjs.map
